import React from 'react'

import { Swiper, SwiperSlide } from "swiper/react";
function NojoomEarnPointsShimmer() {
  

      return (
    <div class="dls-sprint13-comp pt-4 pse_sm mb-5 ">
    <div class="flex_grp_between mb-3  w-40">
        <h3 class="section_title_light mb-0 shimmerBG shimmer-h30"></h3>
    </div>
   
    <Swiper   
        className="sprint14-earn-points gap-2"
        spaceBetween={12}
        pagination={false}
        slidesPerView={ 2}
        grid={{ rows: 1, fill: "row" }}
    >
        <SwiperSlide className="swiper-slide sprint14-colm shimmerBG  " style={{height: '91px'}}>
        </SwiperSlide>
        <SwiperSlide className="swiper-slide sprint14-colm shimmerBG" style={{height: '91px'}}>
        </SwiperSlide>

    </Swiper>
</div>
 
  )
}

export default NojoomEarnPointsShimmer
